import { render, staticRenderFns } from "./HomeHe.vue?vue&type=template&id=5a34d972&"
import script from "./HomeHe.vue?vue&type=script&lang=js&"
export * from "./HomeHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports